module.exports = __webpack_public_path__ + "assets/img/03.75eecd88.png";